export default {
  continueAs: 'Continue as',
  individual: 'Individual',
  corporate: 'Corporate',
  agreeTermsIntro: 'By selecting one of the test version options, you agree to our',
  agreeTerms: 'I agree with the',
  and: 'and',
  privacyPolicy: 'Privacy Policy',
  termsCondition: 'Terms and Condition',
  priadi: 'PRiADI',
  welcome: 'Welcome to @:priadi',
  loginPageSubtitle: 'Login using your @:email and @:password',
  email: 'Email',
  emailHint: 'Enter your email address',
  password: 'Password',
  passwordHint: 'Enter your password',
  fullname: 'Full name',
  fullnameHint: 'Enter your full name',
  rePassword: 'Confirm password',
  rePasswordHint: 'Enter your password again',
  phone: 'Phone number',
  phoneHint: 'Enter your phone number',
  birthdate: 'Date of birth',
  birthdateHint: 'Enter your date of birth',
  signup: 'Sign Up',
  signin: 'Sign In',
  signout: 'Sign out',
  signupText: 'To create an account, please fill out the form below',
  noaccount: 'Not having an account?',
  hasAccount: 'Already having an account?',
  greeting: 'Hello',
  sloganHome: 'Unlock Your True Potential:',
  sloganHomeSubtitle: 'Discover Yourself with PRiADI Psychological Fingerprints',
  testPackage: 'Test Package',
  promo: 'Referral Code / Promo',
  freeConsult: 'Free Consultation',
  noConsult: 'Without Consultation',
  submit: 'Submit',
  contactUs: 'Contact us',
  callCenter: 'Call Center',
  voucherCodeText: 'Get special prices by entering the promo code in the column below',
  voucherCodeHint: 'Insert promo / voucher code here',
  invalidReferralCode: 'Invalid referral code. Please check your code.',
  validReferralCode: 'Referral code accepted! You get a discount.',
  referralCodeError: 'The referral code does not provide any discount.',
  codeApplied: 'Promo code applied successfully!',
  codeInvalid: 'Promo code is invalid or not recognized.',
  features: 'Features',
  includeConsultation: 'Include consultation session',
  selectPackage: 'Select Package',
  selectCounselor: 'Select counselor',
  selectedCounselor: 'Selected counselor',
  consultationType: 'Consultation type',
  counselorName: 'Counselor name',
  cancel: 'Cancel',
  total: 'Total',
  continue: 'Continue',
  online: 'Online',
  offline: 'Offline',
  note: 'notes',
  satisfiedClient: 'satisfied clients',
  edit: 'Change',
  success: 'Success',
  redirectLogin: 'Redirecting to login page',
  validation: {
    required: '{field} cannot be empty.',
    minLength: '{field} must be at least {min} characters.',
    passwordMismatch: 'Passwords do not match.',
    minLowercase: '{field} must be at least contain {min} lowercase character',
    minUppercase: '{field} must be at least contain {min} uppercase character',
    minNumeric: '{field} must be at least contain {min} number',
    minSymbol: '{field} must be at least contain {min} symbol',
  },
  transaction: 'Transaction',
  testResult: 'Test Result',
  testResultMsg: {
    empty: "There's no test result available",
    email: 'The test result will be sent via email',
    corporate: 'Please contact the PIC of the assessment about the test result',
  },
  validUntil: 'Valid until',
  takeATest: 'Take a test',
  checkout: 'Checkout',
  testDone: 'Done',
  checkoutQuestion: 'Are you sure want to checkout?',
  checkoutFailed: "There's an error occurred when checkout",
  confirmation: {
    title: 'Confirmation',
    prompt: 'Are you sure? {optional}',
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    back: 'Back',
  },
  testMethod: 'Test method',
  chooseOne: 'Choose one',
  liveCapture: {
    title: 'Capture finger',
    subtitle: 'Take a photo of your 10 fingers directly using the phone camera',
  },
  uploadFinger: {
    title: 'Upload finger image',
    subtitle: 'Upload a photo of your ten fingers into the form provided.',
    tutorialTitle: 'Before we proceed',
    tutorialSubtitle: 'Please carefully read these instructions below',
    retake: 'Do you want to retake?',
    retakeTitle: 'Retake',
    retakeConfirm: 'Yes, retake',
    retakeCancel: 'No, keep current image',
    finish: 'Finish',
    leftHand: 'Left Hand',
    rightHand: 'Right Hand',
    continuePayment: 'Continue to payment',
    continueTransaction: 'Back to transaction list',
    continueTakeAnother: 'Take another test',
  },
  isRecommended: 'Very recommended for most users',
  bottomNav: {
    home: 'Home',
    transaction: 'Transaction',
    profile: 'My Profile',
    callCenter: 'Call Center',
  },
  changePassword: {
    title: 'Change password',
    newPassword: 'New password',
    oldPassword: 'Old password',
  },
  externalLink: {
    prompt: 'This will take you to an external link',
  },
  createTransaction: {
    title: 'Create Transaction',
    subtitle: 'Fill the form below to continue',
  },
  reset: 'Reset',
  saved: 'Saved',
  failed: 'Failed',
  noTransaction: 'There are no transactions yet',
  guessModalText: 'For the best experience, please log in. Alternatively, you can continue as a guest',
  continueAsGuest: 'Continue as guest',
  capture: {
    beforeProceeding: 'Before We Proceed,',
    watchTutorial: 'Please carefully watch the tutorial below:',
    pleasWait: 'Please wait',
    seconds: 'seconds',
    takeFinger: 'Capture Fingerprints',
    finish: 'Finish',
    fingerGuide: 'Fingerprint Capture Guide',
    continue: 'Continue',
  },
  payment: {
    title: 'Payment Confirmation',
    amountToPay: 'Amount to be paid:',
    bankInfo: 'BNI 353664685 Account Name: Dedi Priadi',
    uploadProof: '*Please upload proof of transfer so your data can be processed immediately.',
    uploadButton: 'Upload Transfer Proof',
    importantInfo: 'Important Information',
    paymentInstructions: [
      'Make payment according to the amount shown to the account listed above',
      'Payment must be made within a maximum of 2 (two) days after taking the test',
      'Test results will be sent via email registered in the transaction within a maximum of 3 (three) working days after payment',
      'Transaction will be canceled if payment date exceeds the specified period'
    ],
    uploadModalTitle: 'Upload Transfer Proof',
    cancel: 'Cancel',
    upload: 'Upload',
  },
  paymentPrompt: {
    proceedToPayment: 'Continue to payment ?',
    yes: 'Yes',
    no: 'No',
  },
  paymentCheckout: {
    title: 'Payment Checkout',
    saved: 'Transaction Saved',
    clickToPayment: 'Click below to proceed to payment',
    processPayment: 'Process Payment',
  },
  paymentSuccess: {
    title: 'Payment Successful!',
    message: 'Your payment has been successfully processed. You will receive your test results via email within several business days.',
    backToTransactions: 'Back to Transactions',
  },
  paymentFailed: {
    title: 'Payment Failed',
    message: 'Your payment was not successful. Please try again or contact',
    customerService: 'our customer service',
    backToTransactions: 'Back to Transactions',
  },
  paymentUnfinished: {
    title: 'Payment Pending',
    message: 'Your payment is still being processed. Please complete payment immediately so your test can be processed.',
    backToTransactions: 'Back to Transactions',
  },
  sessionExpired: 'Session Expired',
  sessionExpiredDesc: 'Your session has expired. Please sign in again.',
  register: {
    title: 'Create account',
    step1Subtitle: 'Create your account to start your assessment',
    step2Subtitle: 'Set up your login credentials',
  },
  months: {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December',
  },
}
